import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, useMemo } from 'react'

import { TopLink } from '@Blocks/ProductList/Components/TopLink/types'
import { SubCategoryItem } from '@Components/Facet/Display/CategoryMenu/SubCategoryItem'
import { ImageV4 } from '@Components/Image'
import { Link } from '@Components/Link'
import { SliderWithArrowsAndIndicator } from '@Components/Slider/SliderWithArrowsAndIndicator'
import { TilesCardGeneric } from '@Components/Tiles/Card/Generic'
import { PagePresentation } from '@Generated/graphql'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { HorizontalCarousel } from '@Shared/Components/Carousels/HorizontalCarousel/HorizontalCarousel'

import styles from './SubCategorySlider.module.scss'

export interface SubCategorySliderProps {
  isMobile?: boolean
  topLinks: TopLink[]
}

export const SubCategorySlider: FC<SubCategorySliderProps> = ({
  isMobile,
  topLinks,
}) => {
  // const missingImages = useMemo(() => some(topLinks, toplink => !toplink.image?.url), [topLinks])
  const missingImages = true
  const topLinksV2 = useSplitTest('top_links_v2', 'b')

  const components = useMemo(() => {
    if (missingImages) {
      return map(topLinks, (topLink) => {
        if (!topLink.type || topLink.type === '') {
          return null
        }
        return (
          <Link
            key={topLink.id!}
            analytics={{
              dest_page_type: pageTypeToDestinationPageType(topLink.type),
              dest_page_type_id: topLink.id || '',
              source_id: 'top_links',
            }}
            className={clsx(
              topLinksV2 ? styles.slide : styles.linkTag,
            )}
            draggable={false}
            href={topLink.url!}
          >
            {(topLink.image)
                && topLinksV2
              ? (
                <TilesCardGeneric
                  key={`top_links_${topLink.title}`}
                  appearance={{
                    backgroundColor: '#F1EBE4',
                    textColor: 'var(--black)',
                  }}
                  cardAspectRatio="square"
                  cardSize="medium"
                  cardVariant="toplink"
                  disableLinks
                  height={80}
                  image={topLink.image.url!}
                  presentation={PagePresentation.Full}
                  title={topLink.title}
                  width={80}
                />

              )
              : (
                <div className={styles.toplinks}>
                  <ImageV4 alt={`${topLink.title}`} src={`${topLink.image?.url}`} width={110} />
                  <p className={styles.topLinkTitle}>{topLink.title!}</p>
                </div>
              )}
          </Link>
        )
      })
    }

    return map(topLinks, topLink => (
      <SubCategoryItem
        key={topLink.id}
        alt={`SubCategoryImage-${topLink.id}`}
        id={topLink.id!}
        image={topLink.image!}
        imageMobile={topLink?.imageMobile || undefined}
        isMobile={isMobile}
        title={topLink.title}
        url={topLink.url!}
      />
    ))
  }, [isMobile, missingImages, topLinks, topLinksV2])

  if (topLinksV2) {
    return (
      <div className={styles.sliderWrapper}>
        <SliderWithArrowsAndIndicator
          className={styles.sliderContainer}
          hideArrows
          sliderClassName={styles.slider}
        >
          {components}
        </SliderWithArrowsAndIndicator>
      </div>
    )
  }

  return (
    <div className={clsx(styles.subCategorySlider, styles.newDesign)}>
      <HorizontalCarousel
        carouselClassName={styles.carousel}
        gap={-1}
        unevenChildWidth={missingImages}
      >
        {components}
      </HorizontalCarousel>
    </div>
  )
}
